// Tracks an explicit locale choice made via the in-page language picker, so axios can forward it
// to the server (Spring's LocaleChangeInterceptor `language` param) - as opposed to the default
// locale, which the server resolves from the Accept-Language header sent natively by the browser/WebView.
let manualLocale: string | null = null;

export function setManualLocale(code: string): void {
    manualLocale = code;
}

export function getManualLocale(): string | null {
    return manualLocale;
}
